import styled from '@emotion/styled'
import { Box, CardContent, Divider, Grid } from '@mui/material'
import Card from '@mui/material/Card'
import Container from '@mui/material/Container'
import { getPxAsRem } from 'shared/utils'

export const Page = styled(Container)`
    padding: ${getPxAsRem(16, 24)};
`
export const StyledCard = styled(Card)`
    padding: ${getPxAsRem(16)};
`
export const StyledEmptyCardContent = styled(CardContent)`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: ${getPxAsRem(16)};
    justify-content: center;
    margin-top: ${getPxAsRem(16)};
    padding: ${getPxAsRem(24)};
    text-align: center;
`
export const TitleContainer = styled(Grid)`
    padding-bottom: ${getPxAsRem(24)};
`
export const SectionHeaderContainer = styled.div`
    padding-bottom: ${getPxAsRem(16)};
`
export const SectionTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${({ theme }) => theme.palette.secondary.dark};
    font-size: ${getPxAsRem(14)};
`
export const StyledSubtext = styled.div`
    align-items: center;
    font-size: ${getPxAsRem(14)};
    padding-top: ${getPxAsRem(10)};
    color: ${({ theme }) => theme.palette.other.secondary_light};
`
export const EditButtonContainer = styled(Grid)`
    display: flex;
    gap: ${getPxAsRem(8)};
`
export const Separator = styled(Divider)`
    margin: ${getPxAsRem(24, 0)};
`

export const SpaceBetweenRow = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
